// extracted by mini-css-extract-plugin
export default {"list":"AlertList_list__VPVEk"};